import type { enGudang } from '../en/gudang';

export const idGudang: Record<keyof typeof enGudang, string> = {
  'gudang.nav.overview': 'Ringkasan',
  'gudang.overview.title': 'Gudang',
  'gudang.overview.subtitle': 'Gudang di {branch}',
  'gudang.overview.warehouses': 'Gudang',
  'gudang.overview.warehousesDesc':
    'Setiap lokasi stok yang aktif adalah gudang. Zona dan rak diatur per gudang.',
  'gudang.overview.empty': 'Belum ada lokasi stok yang aktif.',
  'gudang.overview.addLocation': 'Tambah lokasi',
  'gudang.overview.default': 'Utama',
  'gudang.overview.binsPending': 'Belum ada zona atau rak — stok dicatat per lokasi.',
};
